import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {finalize, takeUntil} from 'rxjs/operators';

@Injectable()
export class CancelPaginatedRequestsInterceptor implements HttpInterceptor {
  private readonly pending = new Map<string, Subject<void>>();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.shouldCancel(req)) {
      return next.handle(req);
    }

    const key = this.buildKey(req);
    const previous = this.pending.get(key);
    if (previous) {
      previous.next();
      previous.complete();
    }

    const cancel$ = new Subject<void>();
    this.pending.set(key, cancel$);

    return next.handle(req).pipe(
      takeUntil(cancel$),
      finalize(() => {
        const current = this.pending.get(key);
        if (current === cancel$) {
          this.pending.delete(key);
        }
      })
    );
  }

  private shouldCancel(req: HttpRequest<any>): boolean {
    if (req.method !== 'GET') return false;
    return req.params.has('page') || req.params.has('size');
  }

  private buildKey(req: HttpRequest<any>): string {
    return `${req.method} ${req.urlWithParams}`;
  }
}
